// extracted by mini-css-extract-plugin
module.exports = {"resultItem":"ResultItem_resultItem__B6q3d","favoriteIcon":"ResultItem_favoriteIcon__sFKcc","upsellAd":"ResultItem_upsellAd__8wNFC"};